"use client";

import { c as _c } from "react/compiler-runtime";
import { CourseCard } from "@/components/common/course-card";
import { RenderIf } from "@/components/common/render-if";
import { SeoHeading } from "@/components/common/seo-heading";
import { StructuredData } from "@/components/common/structured-data";
import { Section } from "@/components/section";
import { Box } from "@/components/ui/box";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Text } from "@/components/ui/text";
import { getWorkloadInISO } from "@/helpers/get-workload-iso";
import useConstantValueList from "@/hooks/use-constant-value-list";
import { useMemo, useState } from "react";
type CoursesWithLevelFilterProps = {
  section: PageSections;
  data: {
    heading?: string;
    seoHeading?: string;
    coursesWithLevelFilter: ServiceByTypeInterface[];
  };
};
const CoursesWithLevelFilter = t0 => {
  const $ = _c(47);
  const {
    data,
    section
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date().toISOString();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const currentDateISO = t1;
  let t2;
  if ($[1] !== data.coursesWithLevelFilter) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = (item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Course",
          url: `${process.env.NEXT_PUBLIC_APP_URL}/course/${item.slug}/`,
          name: item.name,
          description: item.description || item.name || "No description available",
          provider: {
            "@type": "Organization",
            name: "Spoclearn",
            sameAs: process.env.NEXT_PUBLIC_APP_URL
          },
          hasCourseInstance: {
            "@type": "CourseInstance",
            courseMode: item.mode_of_training?.includes("Live") ? "Online" : "Blended",
            location: "Spoclearn",
            courseSchedule: {
              "@type": "Schedule",
              duration: getWorkloadInISO(item.serviceTrainingDays || "16 Hrs"),
              repeatFrequency: "Daily",
              repeatCount: 5,
              startDate: item.startDate || "2025-09-01",
              endDate: item.endDate || "2025-09-30"
            }
          },
          offers: {
            "@type": "Offer",
            url: `${process.env.NEXT_PUBLIC_APP_URL}/course/${item.slug}/`,
            priceCurrency: item.currency || "USD",
            price: item.price || "100",
            availability: "https://schema.org/InStock",
            validFrom: item.startDate || currentDateISO,
            category: item?.category || "Technology",
            seller: {
              "@type": "Organization",
              name: "Spoclearn",
              sameAs: process.env.NEXT_PUBLIC_APP_URL
            }
          }
        }
      });
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = data.coursesWithLevelFilter.map(t3);
    $[1] = data.coursesWithLevelFilter;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const courseListSchema = t3;
  const {
    data: serviceLabels
  } = useConstantValueList("SERVICES_LEVELS");
  const [filter, setFilter] = useState("240");
  const t4 = `${section.sectionClass} scroll-m-16.5!`;
  const t5 = data?.seoHeading;
  const t6 = data?.heading;
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <SeoHeading as="h2" seoHeading={t5} heading={t6} />;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = !data.heading && !data.seoHeading;
  let t9;
  if ($[9] !== data.coursesWithLevelFilter || $[10] !== filter) {
    t9 = data.coursesWithLevelFilter?.filter(item_0 => filter === "240" ? true : item_0.serviceLevelId == filter).length;
    $[9] = data.coursesWithLevelFilter;
    $[10] = filter;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = `All Courses (${t9})`;
  let t11;
  if ($[12] !== t10) {
    t11 = <Text className="shrink-0">{t10}</Text>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t8) {
    t12 = <RenderIf condition={t8}>{t11}</RenderIf>;
    $[14] = t11;
    $[15] = t8;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t7) {
    t13 = <span>{t7}{t12}</span>;
    $[17] = t12;
    $[18] = t7;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = val => setFilter(val);
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SelectTrigger className="w-full sm:w-auto"><SelectValue /></SelectTrigger>;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SelectLabel>Lavel</SelectLabel>;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== serviceLabels) {
    t17 = serviceLabels?.map(_temp);
    $[23] = serviceLabels;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t17) {
    t18 = <SelectContent alignItemWithTrigger={false}><SelectGroup>{t16}{t17}</SelectGroup></SelectContent>;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== filter || $[28] !== serviceLabels || $[29] !== t18) {
    t19 = <div className="w-full sm:ml-auto sm:w-auto sm:shrink-0"><Select value={filter} items={serviceLabels} onValueChange={t14}>{t15}{t18}</Select></div>;
    $[27] = filter;
    $[28] = serviceLabels;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t13 || $[32] !== t19) {
    t20 = <Box className="mb-4 flex flex-col gap-4 sm:flex-row sm:items-center">{t13}{t19}</Box>;
    $[31] = t13;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== data.coursesWithLevelFilter || $[35] !== filter) {
    t21 = data.coursesWithLevelFilter?.filter(item_2 => filter === "240" ? true : item_2.serviceLevelId == filter).map(_temp2);
    $[34] = data.coursesWithLevelFilter;
    $[35] = filter;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21) {
    t22 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">{t21}</div>;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== courseListSchema) {
    t23 = <StructuredData data={courseListSchema} />;
    $[39] = courseListSchema;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== section.sectionId || $[42] !== t20 || $[43] !== t22 || $[44] !== t23 || $[45] !== t4) {
    t24 = <Section id={section.sectionId} className={t4}>{t20}{t22}{t23}</Section>;
    $[41] = section.sectionId;
    $[42] = t20;
    $[43] = t22;
    $[44] = t23;
    $[45] = t4;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  return t24;
};
export default CoursesWithLevelFilter;
function _temp(item_1) {
  return <SelectItem key={item_1.value} value={item_1.value}>{item_1.label}</SelectItem>;
}
function _temp2(item_3) {
  return <div key={`categorized-course-${item_3.id}`}><CourseCard serviceId={item_3.id} name={item_3.name} image={item_3.service_image} totalEnroll={item_3.numberOfLearners} duration={item_3.serviceTrainingDays} slug={item_3.slug} accreditation_name={item_3.accreditation_name} icon={item_3.serviceIcon} modeOfTraining={item_3.mode_of_training || "Live Classroom / Classroom"} sellingPriceNumber={item_3.price} currency={item_3.currency} serviceFlags={item_3.serviceFlags} isGenericPageOnly={item_3.isGenericPageOnly} /></div>;
}